/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.8.0",
  "gitBuildTime": "2026-10-05T16:09:37.169Z",
  "gitBuildVersion": "1.8.0",
  "gitCommitId": "33bea44",
  "gitCommitIdFull": "33bea44ae0711e6337cbff7718b04308928a71da",
  "gitCommitTime": "2026-10-05T15:44:05.000Z",
  "version": "1.8.0-2026-10-05T15:44:05.000Z-(33bea44)"
};
